import { Box, Stack, styled } from '@mui/material'

export const MainContent = styled(Box)<{ isexpanded?: number; mode?: string }>(({ theme, isexpanded, mode }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'row',
  flexGrow: 1,
  minHeight: 0,
  gap: isexpanded ? 0 : (mode === 'expand' ? 0 : theme.spacing(5)),
  height: mode === 'expand' ? 0 : 'auto',
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(2),
  transition: 'all 0.3s ease-in-out',
  overflow: mode === 'expand' ? 'hidden' : 'visible',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    height: isexpanded ? '100%' : 'auto',
    gap: isexpanded ? 0 : theme.spacing(3)
  }
}))

export const MapContainer = styled(Box)({
  display: 'flex',
  flexGrow: 1,
  position: 'relative',
  borderRadius: '12px',
  height: '100%',
  width: '100%'
})

export const MapTitle = styled(Stack)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(2),
  zIndex: 10,
  height: theme.spacing(4),
  alignItems: 'center',
  backgroundColor: 'rgba(255,255,255, .8)',
  padding: theme.spacing(0, 2),
  backdropFilter: 'blur(6px)',
  borderRadius: theme.spacing(0, 0.5, 0.5, 0),
  overflow: 'hidden',
  boxShadow: '0px 8px 16px -6px rgba(0, 0, 0, 0.24)',
}))

export const MapLink = styled(Stack)(({ theme }) => ({
  position: 'absolute', 
  top: theme.spacing(2),
  right: '0px',
  height: theme.spacing(4),
  zIndex: 10,
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'rgba(255,255,255, .8)',
  padding: theme.spacing(0, 1.5),
  backdropFilter: 'blur(6px)',
  borderRadius: theme.spacing(0.5, 0, 0, 0.5),
  overflow: 'hidden',
  boxShadow: '0px 8px 16px -6px rgba(0, 0, 0, 0.24)',
}))

export const WrapperMapAccount = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  minHeight: theme.spacing(34),
  gap: theme.spacing(5),
  justifyContent: 'space-between',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    gap: theme.spacing(3)
  }
}))

export const WrapperStats = styled(Stack)(({ theme }) => ({
  flex: 1,
  border: '1px solid #e0ebf5',
  borderRadius: theme.spacing(1),
  gap: theme.spacing(1),
  padding: theme.spacing(1.5, 3, 3),
}))

export const MapOnly = styled(Box)<{ isexpanded?: number }>(({ theme, isexpanded }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  flexGrow: 1,
  width: '100%',
  height: isexpanded ? '100%' : 'auto',
  minHeight: isexpanded ? 0 : theme.spacing(40),
  zIndex: 'auto',
  backgroundColor: 'transparent',
  borderRadius: theme.spacing(1.5),
  transition: 'all 0.3s ease-in-out',
  [theme.breakpoints.down('md')]: {
    minHeight: isexpanded ? 0 : theme.spacing(30),
    order: 2,
    height: isexpanded ? '100%' : 'auto'
  }
}))

export const SideContent = styled(Stack)<{ isexpanded?: number }>(({ theme, isexpanded }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  width: isexpanded ? 0 : '560px',
  opacity: isexpanded ? 0 : 1,
  overflow: isexpanded ? 'hidden' : 'visible',
  transition: 'all 0.3s ease-in-out',
  [theme.breakpoints.down('md')]: {
    width: isexpanded ? 0 : '100%',
    height: isexpanded ? 0 : 'auto',
    minHeight: isexpanded ? 0 : 'auto',
    flexBasis: isexpanded ? 0 : 'auto',
    order: 1
  }
}))

export const TableContent = styled(Stack)<{ mode: string }>(({ theme, mode }) => ({
  position: 'relative',
  width: mode === 'expand' ? '100%' : 'clamp(360px, 480px, 560px)',
  display: 'flex',
  gap: 0,
  [theme.breakpoints.down('md')]: {
    width: '100%',
    order: 3
  }
}))
